import { render, staticRenderFns } from "./waitCertification.vue?vue&type=template&id=784403b1&scoped=true&"
import script from "./waitCertification.vue?vue&type=script&lang=js&"
export * from "./waitCertification.vue?vue&type=script&lang=js&"
import style0 from "./waitCertification.vue?vue&type=style&index=0&id=784403b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784403b1",
  null
  
)

export default component.exports